<div class="flex-column">
    <div class="flex-fill flex-scroll">
        <div *ngFor="let file of files" class="list-item">
            <div class="info">
                <img class="thumbnail" id="{{file.id}}" #imagePreview alt="">
            </div>
            <div class="content">
                <div class="title">{{file.name}}</div>
                <div class="description">
                    <p-progressBar class="progress-bar" [value]="file.progress"></p-progressBar>
                </div>
            </div>

            <div class="info">
                <span class="tag" [ngClass]="file.status">{{file.status}}</span>
            </div>

            <div class="info">
                <button type="button" class="btn btn-primary"><i class="fa fa-pause"></i></button>
                <button type="button" class="btn btn-danger"><i class="fa fa-trash"></i></button>
            </div>

        </div>
    </div>
</div>